import * as React from 'react';

interface Props {
  content: string;
}

const SearchError: React.FC<Props> = (props) => {
  return (
    <div className="error-info">
      <span>{props.content}</span>
    </div>
  );
};

export default SearchError;
